import React from "react";
import { useAssetsReturnModel } from "../assetsReturnModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOrgModel } from "@/views/base/organization/orgModel";




export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAssetsReturnModel();
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "归还单号",
            fieldName: "code",
            span:4
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "归还人员",
            fieldName: "user",
            span:4
        }, {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "归还部门",
            fieldName: "department",
            span:4,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        }, 
        // {
        //     type: SearchTypeEnum.Input,
        //     placeholder: "存放地点",
        //     fieldName: "deposit",
        //     span:4
        // },  
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["归还起始日期", "归还结束日期"],
            format: "YYYY-MM-DD",
            alloc: true,
            span:4
        }, 
    ]

    return (
        <YhPageHeader
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}